import { WHATSAPP_MESSAGE, WHATSAPP_NUMBER } from '../../config/siteContent';

const WhatsAppButton = () => {
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

  return (
    <a
      className="whatsapp-floating-button"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Consultar por WhatsApp"
      title="Consultar por WhatsApp"
    >
      <i className="fa-brands fa-whatsapp" aria-hidden="true" />
      <span>WhatsApp</span>
    </a>
  );
};

export default WhatsAppButton;
